var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "app-modal",
    {
      staticClass: "modal-login",
      attrs: { shown: _vm.shown },
      on: { close: _vm.handleClose },
    },
    [
      _c("div", { staticClass: "center-content-position" }, [
        _c("div", [
          _c("h1", [_vm._v("Account details")]),
          _vm._v(" "),
          _c("div", { staticClass: "user-details" }, [
            _c("div", { staticClass: "user-details-item" }, [
              _c("div", { staticClass: "item-left" }, [
                _c("span", [_vm._v("User Name")]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-right" }, [
                _c("span", [_vm._v(_vm._s(_vm.user.name))]),
                _vm._v(" "),
                _vm.internal ? _c("span", [_vm._v(" (internal)")]) : _vm._e(),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "user-details" }, [
            _c("div", { staticClass: "user-details-item" }, [
              _c("div", { staticClass: "item-left" }, [
                _c("span", [_vm._v("User ID")]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-right" }, [
                _c("span", [_vm._v(_vm._s(_vm.user.userId))]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "user-details" }, [
            _c("div", { staticClass: "user-details-item" }, [
              _c("div", { staticClass: "item-left" }, [
                _c("span", [_vm._v("Subscription")]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-right" }, [
                _c("span", [_vm._v(_vm._s(_vm.subscriptionText))]),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "center-content-position" }, [
        _c("div", { staticClass: "modal-footer" }, [
          _c("span", { staticClass: "app-version-number" }, [
            _vm._v("V " + _vm._s(_vm.version)),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "cta-button medium-button-dark",
              on: { click: _vm.showIntercom },
            },
            [_vm._v("\n          Discuss Subscription\n        ")]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }